export enum TaxQualifiedAnalysisType {
	ALL = 'all',
	MIXED = 'mixed',
	NONE = 'none'
};
